import { Directive, HostListener, Input } from '@angular/core';

/**
 * numberOnly
 */
@Directive({
	selector: '[numberOnly]'
})
export class OnlyNumberDirective {
	@Input() numberOnly: string;
	private readonly allowableKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];
	private allowablePatternPositive: RegExp = new RegExp(/^\d+$/); // Digits only
	private allowablePatternNegative: RegExp = new RegExp(/^[-+]?\d*$/); // Digits only

	@HostListener('keydown', ['$event'])
	public onKeyDown(event: KeyboardEvent): void {
		if (this.allowableKeys.includes(event.key)) {
			return;
		}

		// A user may select all or part of an existing input's value to replace
		const selectionStart: number = (event.currentTarget as HTMLInputElement).selectionStart;
		const selectionEnd: number = (event.currentTarget as HTMLInputElement).selectionEnd;

		const currentValue: string = (event.currentTarget as HTMLInputElement).value;

		// This is replacing a selection with the pressed key
		const proposedValue: string = [
			currentValue.slice(0, selectionStart),
			event.key,
			currentValue.slice(selectionEnd)
		].join('');

		if (this.numberOnly === 'positiveNumbers' && !proposedValue.match(this.allowablePatternPositive)) {
			event.preventDefault();
		}
		if (this.numberOnly === 'negativeNumbers' && !proposedValue.match(this.allowablePatternNegative)) {
			event.preventDefault();
		}
	}
}
